import type { HeaderMetadataState } from './types';

export const EMPTY_HEADER_METADATA: HeaderMetadataState = {
  author: '',
  bay: '',
  child: '',
  created: '',
  headerTreatmentPlanId: null,
  pageId: null,
  pageIdPrefix: '',
  status: '',
  title: '',
};
